import http from '../utils/http';

const deviceApi = {
    /**
     * 终端-分页条件查询设备列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#183
     *
     * @param {Object} options
     */
    getDeviceList(options) {
        return http.post('/device/list', options, {
            showLoading: '数据加载中...',
            needLogin: true,
        })
    },

    /**
     * 终端分组-获取所有分组树形结构
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#166
     */
    getDeviceGroup(param) {
        return http.post('/devicegroup/tree', param)
    },

    /**
     * 终端分组-移动终端到某个分组下
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#183
     *
     * @param {string} deviceCodes
     * @param {number} deviceGroupId
     */
    deviceGroupMove(deviceCodes, deviceGroupId) {
        return http.post('/devicegroup/move', { deviceCodes, deviceGroupId })
    },

    /**
     * 终端-修改设置信息-远程关机
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#187
     *
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     */
    deviceShutdown(deviceCodes) {
        return http.post('/device/shutdown', { deviceCodes })
    },

    /**
     * 终端-修改设置信息-重启终端
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#187
     *
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     */
    deviceRestart(deviceCodes) {
        return http.post('/device/restart', { deviceCodes })
    },

    /**
     * 终端-修改设置信息-音量设置
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#187
     *
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     * @param deviceVolume	音量值	number
     */
    setVolume(deviceCodes, deviceVolume) {
        return http.post('/device/setVolume', { deviceCodes, deviceVolume })
    },

    /**
     * 终端-修改设置信息-解绑终端
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#187
     *
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     */
    deviceUntie(deviceCodes, deviceVolume) {
        return http.post('/device/untie', { deviceCodes, deviceVolume })
    },

    /**
     * 终端-修改设置信息-定时开关
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#187
     *
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     * @param bootTime	开启时间	string
     * @param offTime	关闭时间	string
     * @param nonWorkDayBootTime	非工作日开启时间	string
     * @param nonWorkDayOffTime	非工作日关闭时间	string
     */
    setTimerShutDownOrStart(param) {
        return http.post('/device/setTimerShutDownOrStart', param)
    },

    /**
     * 终端-发布节目-节目来源
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#159
     */
    getGlobalconfig() {
        return http.post('/globalconfig')
    },

    /**
     * 终端-发布节目-投放区域
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#159
     */
    getDeviceGroupSelect() {
        return http.post('/program/getDeviceGroupSelect')
    },

    /**
     * 终端-发布节目-节目列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#214
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     * @param bprogramName	节目名称	string
     * @param programOrigin	节目来源	string
     * @param deviceGroupId	头发区域	Number
     */
    getProgramByDevices(params) {
        return http.post('/program/getProgramByDevices', params, {
            showLoading: '请求中...',
            needLogin: true,
        })
    },

    /**
     * 节目详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    getApkList(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/getApkList', options, {
            ...config
        });
    },


    /**
     * 终端-发布节目-发布节目
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#216
     * @param deviceCodes	操作的终端，多个用逗号隔开	string
     * @param programVersions	节目版本号	string
     */
    fastPublishByProgramAndPointer(deviceCodes, programVersions) {
        return http.post('/program/fastPublishByProgramAndPointer', 
            {   
                deviceCodes, 
                programVersions 
            },
            )
    },

    /**
     * 终端-文件增播-素材类型
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#156
     */
    getAllFileType() {
        return http.post('/fileType/getAllFileType')
    },

    /**
     * 终端-文件增播-素材分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#157
     * @param fileType	素材类型编码	string
     */
    getFileGroup() {
        return http.post('/fileGroup/getFileGroup')
    },

    /**
     * 终端-文件增播-素材列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#152
     * @param fileType	素材类型编码	string
     * @param fileName	素材名称	string
     */
    getFileByPage(param) {
        return http.post('/file/getFileByPage', param)
    },

    /**
     * 终端-文件增播-确定增播
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#152
     * @param param
     */
    getProgramAdded(param) {
        return http.post('/program/added', param, {
            showLoading: '发送中...',
            needLogin: false,
        })
    },

    /**
     * 终端-文件增播-节目列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#152
     * @param deviceCode	终端序列号	string
     */
    getCurrentSourcesByDeviceCode(param) {
        return http.post('/program/getCurrentSourcesByDeviceCode', param)
    },

    /**
     * 终端-文件增播-节目减播
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#152
     * @param deviceCode	终端序列号	string
     */
    programReduce(deviceCode, sourceJson) {
        return http.post('/program/reduce', { deviceCode, sourceJson },{
            showLoading: '发送中...',
        })
    },

    /**
     * 添加apk
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    addApk(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/addApk', options, {
            // successMsg: true,
            ...config
        });
    },

    /**
     * 添加apk
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    editApk(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/editApk', options, {
            // successMsg: true,
            ...config
        });
    },

    /**
     * 删除apk
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    deleteApk(deviceUpgradeId, config = {}) {
        return http.post('/DeviceUpgrade/deleteApk', { deviceUpgradeId }, {
            // successMsg: false,
            ...config
        });
    },

    /**
     * 获取apk升级详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    deviceUpgradeInfo(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/deviceUpgradeInfo', options, {
            ...config
        });
    },

    /**
     * 查看apk升级数量详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    apkUpgradeNumDetail(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/getApkUpgradeNumDetail', options, {
            ...config
        });
    },

    /**
     * 根据deviceCode获取详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#184
     * @param param 请求参数
     */
    getDeviceDetail (param) {
        return http.post('/device/detail', param, {
            showLoading: '请求中...',
            needLogin: false,
        })
    },

    /**
     * 终端-修改详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#188
     * @param param 请求参数
     */
    getDeviceUpdate (param) {
        let deviceCode = param.deviceCode
        return http.post('/device/update/' + deviceCode, param, {
            showLoading: '请求中...',
            needLogin: false,
        })
    },

    /**
     * 节目减播列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#263
     * @param param 请求参数
     */
    programReducedLog (param) {
        return http.post('/programReducedLog/list', param, {
            needLogin: false,
        })
    },

    /**
     * 终端增播日志
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#273
     * @param param 请求参数
     */
    getAddedSourcesByDeviceCode (param) {
        return http.post('/program/getAddedSourcesByDeviceCode', param, {
            needLogin: false,
        })
    },


    /**
     * 删除节目
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#263
     * @param param 请求参数
     */
    programDelete (param) {
        return http.post('/program/delete', param, {
            needLogin: false,
        })
    },

    /**
     * 终端分组-修改分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#162
     * @param param 请求参数
     */
    updateDevicegroup (param) {
        return http.post('/devicegroup/update', param, {
            needLogin: false,
        })
    },

    /**
     * 终端分组-删除分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#163
     * @param param 请求参数
     */
    deleteDevicegroup (param) {
        return http.post('/devicegroup/delete', param, {
            needLogin: false,
        })
    },

    /**
     * 终端分组-新增分组
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#164
     * @param param 请求参数
     */
    addDevicegroup (param) {
        return http.post('/devicegroup/save', param, {
            needLogin: false,
        })
    },

    /**
     * 选择终端升级pak
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    upgradeApkToMips(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/upgradeApkToMips', options, {
            ...config
        });
    },

    /**
     * 根据id获取apk详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options 请求选项
     * @param {Object} config axios配置
     * @returns Promise
     */
    getApkById(options = {}, config = {}) {
        return http.post('/DeviceUpgrade/getApkById', options, {
            ...config
        });
    },

    /**
     * 导出
     */
    exportDeviceExcel(options = {}, config = {}) {
        console.log(options, "----> options");
        console.log(config, "----> config");
        return http.get('/device/exportDeviceExcel', options, {
            ...config
        });
    },
}

export default deviceApi;
